import { useAuth0 } from "@auth0/auth0-react";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import PrimaryButton from "components/PrimaryButton";
import React from "react";
import { FormattedMessage } from "react-intl";

interface Props {
  authError?: Error | undefined;
}

function AccessDenied({ authError }: Props) {
  const [open, setOpen] = React.useState(true);

  const { logout } = useAuth0();

  const handleClose = (event?: object, reason?: string) => {
    if (reason === "buttonClicked") setOpen(false);
  };

  const handleAccept = () => {
    logout({ returnTo: window.location.origin + window.location.pathname });
    handleClose(undefined, "buttonClicked");
  };

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      fullWidth={true}
      maxWidth={"sm"}
    >
      <DialogTitle id="alert-dialog-title">
        <FormattedMessage id="auth0.accessDeniedTitle" />
      </DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description" component={"span"}>
          <div className="display-linebreak">
            {authError && authError.message === "verify_email" && (
              <FormattedMessage id="auth0.verifyEmail" />
            )}
            {(!authError || authError.message !== "verify_email") && (
              <FormattedMessage id="auth0.accessDenied" />
            )}
            {authError && authError.message !== "verify_email" && (
              <div>
                <strong>{authError.message}</strong>
              </div>
            )}
          </div>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <PrimaryButton
          onClick={() => {
            window.location.reload();
          }}
          style={{ marginLeft: "8px", minWidth: "100px" }}
        >
          <FormattedMessage id="auth0.refresh" />
        </PrimaryButton>

        <PrimaryButton onClick={handleAccept} style={{ marginLeft: "8px", minWidth: "100px" }}>
          <FormattedMessage id="menu.signOut" />
        </PrimaryButton>
      </DialogActions>
    </Dialog>
  );
}

export default AccessDenied;
